import { render, staticRenderFns } from "./kadarrespon-old.vue?vue&type=template&id=da93f08a&scoped=true"
import script from "./kadarrespon-old.vue?vue&type=script&lang=js"
export * from "./kadarrespon-old.vue?vue&type=script&lang=js"
import style0 from "./kadarrespon-old.vue?vue&type=style&index=0&id=da93f08a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da93f08a",
  null
  
)

export default component.exports